import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import TrendingPage from './pages/TrendingPage';
import CataloguePage from './pages/CataloguePage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import WishlistPage from './pages/WishlistPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import { DashboardPage, PrivacyPolicyPage, RefundPolicyPage, TermsPage } from './pages/OtherPages';

// Lazy-load CheckoutPage so Stripe.js is only fetched when the user navigates to /checkout.
// Without lazy(), importing CheckoutPage at the top would run loadStripe() on every page load.
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        {/* Suspense is required for React.lazy — shows nothing while CheckoutPage chunk loads */}
        <Suspense fallback={null}>
          <Routes>
            <Route path="/"               element={<HomePage />} />
            <Route path="/shop"           element={<ShopPage />} />
            <Route path="/trending"       element={<TrendingPage />} />
            <Route path="/catalogue"      element={<CataloguePage />} />
            <Route path="/product/:id"    element={<ProductDetailPage />} />
            <Route path="/cart"           element={<CartPage />} />
            <Route path="/wishlist"       element={<WishlistPage />} />
            <Route path="/checkout"       element={<CheckoutPage />} />
            <Route path="/login"         element={<LoginPage />} />
            <Route path="/register"       element={<RegisterPage />} />
            <Route path="/dashboard"      element={<DashboardPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/refund-policy"  element={<RefundPolicyPage />} />
            <Route path="/terms"          element={<TermsPage />} />
            {/* Safe catch-all: unknown routes → home */}
            <Route path="*"               element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </main>
      {pathname !== '/checkout' && <Footer />}
    </>
  );
}

// Fixed: Removed the redundant <BrowserRouter> wrapper from here
export default function App() {
  return (
    <AuthProvider>
      <StoreProvider>
        <AppLayout />
      </StoreProvider>
    </AuthProvider>
  );
}